const escapeRegExp = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Server-rendered legacy bodies often re-state the actor and the current
// resource, both of which are already shown in the card chrome. Strip those
// references plus any orphaned "Owner: <actor>" metadata so the card reads as
// a short event summary instead of a duplicated audit log.
export const cleanLegacyBody = (
  body: string,
  actorName: string | null | undefined,
  actorDisplayName: string | null | undefined,
  primaryResource: string | null | undefined,
): string => {
  let cleaned = body;

  cleaned = cleaned.replace(/@\[([^\]]*)\]\(([^)]+)\)/g, (match, _text, ref) =>
    ref === actorName || ref === primaryResource ? '' : match,
  );

  if (actorDisplayName) {
    const name = escapeRegExp(actorDisplayName);
    cleaned = cleaned.replace(
      new RegExp(`\\s*\\*+\\s*Owner:\\s*\\*+\\s*${name}\\s*$`, 'i'),
      '',
    );
    cleaned = cleaned.replace(
      new RegExp(`\\s*Owner:\\s*${name}\\s*$`, 'i'),
      '',
    );
  }
  cleaned = cleaned.replace(/\s*\*+\s*Owner:\s*\*+\s*$/i, '');
  cleaned = cleaned.replace(/\s*Owner:\s*$/i, '');

  cleaned = cleaned.replace(/\*\*\s*\*\*/g, '');
  cleaned = cleaned.replace(/__\s*__/g, '');

  return cleaned.replace(/\s+/g, ' ').trim();
};
